/** @format */

import { clientsConstants } from './actions';
import { notificationConstants } from '../notifications/notifications';
import { reducerDebug } from '../../core/debug';

export function clientsReducers(state = {}, action) {
    reducerDebug('Clients reducer: ' + action.type);
    switch (action.type) {
        case clientsConstants.CLIENTS_LIST:
            return {
                type: action.type,
                collections: action.collections,
            };
        case clientsConstants.CLIENT_LIST_SHORT:
            return {
                type: action.type,
                collectionsShort: action.collections,
            };
        case clientsConstants.CLIENTS_ITEM:
            return {
                type: action.type,
                clientItem: action.item,
            };
        case clientsConstants.CLIENT_ADD:
        case clientsConstants.CLIENTS_EDIT:
            return {
                type: action.type,
                success: true,
                data: action.data,
            };
        case clientsConstants.CLIENTS_DELETE:
            return {
                type: action.type,
                deletedSuccess: true,
            };
        case clientsConstants.CLIENT_STREET_CHECK:
            return {
                ...state,
                type: action.type,
                streets: action.collections,
            };
        case clientsConstants.CLIENT_CITY_CHECK:
            return {
                ...state,
                type: action.type,
                cities: action.collections,
            };
        case clientsConstants.CLIENT_BOROUGH_CHECK:
            return {
                ...state,
                type: action.type,
                boroughs: action.collections,
            };
        case clientsConstants.CLIENT_DISTRICT_CHECK:
            return {
                ...state,
                type: action.type,
                districts: action.collections,
            };
        case clientsConstants.CLIENT_STATE_CHECK:
            return {
                ...state,
                type: action.type,
                states: action.collections,
            };
        case notificationConstants.ERROR:
            return {
                type: action.type,
                message: action.message,
            };
        default:
            return {
                ...state,
                success: false,
                deletedSuccess: false,
                type: action.type,
            };
    }
}
